module.exports = __webpack_public_path__ + "img/image_offline02@2x.273ab48c.png";